import { render, staticRenderFns } from "./IconBlock.vue?vue&type=template&id=075532c1&"
import script from "./IconBlock.vue?vue&type=script&lang=js&"
export * from "./IconBlock.vue?vue&type=script&lang=js&"
import style0 from "./IconBlock.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports